import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-9a8d3a1c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "90%",
    "margin-left": "5%"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "float": "right"
  }
};
const _hoisted_3 = {
  key: 0,
  class: "col_bblue"
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 0,
  style: {
    "margin-bottom": "20px"
  }
};
const _hoisted_6 = {
  key: 1,
  style: {
    "color": "rgb(126,127,134)",
    "margin-left": "30px"
  }
};
const _hoisted_7 = {
  key: 2
};
const _hoisted_8 = {
  style: {
    "margin-bottom": "20px"
  }
};
const _hoisted_9 = {
  key: 3,
  style: {
    "margin": "20px 0 0 10px",
    "color": "#D9001B",
    "display": "flex"
  }
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 补充备注: ", -1));

const _hoisted_11 = {
  style: {
    "margin-left": "5%",
    "width": "80%",
    "word-wrap": "break-word"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [$props.dpt.status && $props.dpt.status != '1' && $props.dpt.status != '5' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [$props.dpt.status == '2' ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 审核中 ")) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass($options.getClassByStatus($data.dataInfo.answerVo.checkStatus))
  }, _toDisplayString($data.dataInfo.answerVo.checkStatusName), 3))])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass($data.dataInfo.isEssential ? 'star' : ''),
    style: {
      "font-weight": "bold",
      "margin-bottom": "20px",
      "font-size": "14px",
      "word-wrap": "break-word"
    }
  }, _toDisplayString($props.listIndex) + "." + _toDisplayString($data.dataInfo.title || '请输入标题'), 3), $props.dpt.status ? (_openBlock(), _createElementBlock("div", _hoisted_4, [$data.dataInfo.answerVo.content && $data.dataInfo.answerVo.content != 'null' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_input, {
    modelValue: $data.dataInfo.content,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.dataInfo.content = $event),
    placeholder: "请输入内容",
    type: "textarea",
    disabled: ""
  }, null, 8, ["modelValue"])])) : (_openBlock(), _createElementBlock("div", _hoisted_6, " 用户未填报 "))])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_input, {
    modelValue: $data.dataInfo.content,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.dataInfo.content = $event),
    placeholder: "请输入内容",
    type: "textarea",
    disabled: ""
  }, null, 8, ["modelValue"])])])), $data.dataInfo.answerVo?.checkStatus === '1' && $props.dpt.status != '2' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString($data.dataInfo.answerVo.checkRemark), 1)])) : _createCommentVNode("", true)])]);
}